/**
 * This screen is displayed after successful form submission.
 */
const Success = () => (
  <div className='centered-container'>
    <div className='success-content'>
      <img
        src='success.svg'
        className='svg-illustration'
        alt='Success illustratie'
      />
      <div className='success-text-wrapper'>
        <h3>Gelukt!</h3>
        <p className='success-subtitle'>Uw klus is ontvangen</p>
        <div className='success-callout'>
          <svg
            className='success-callout-icon'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            aria-hidden='true'
          >
            <circle
              cx='12'
              cy='12'
              r='9'
              stroke='currentColor'
              strokeWidth='2'
            />
            <path
              d='M12 7v5l3 2'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          <span>
            We nemen binnen <strong>drie werkdagen</strong> contact op
          </span>
        </div>
      </div>
      <button
        className='button'
        onClick={(e) => {
          e.preventDefault();
          window.location.href = 'https://www.klusminuten.nl';
        }}
      >
        Verder
      </button>
    </div>
  </div>
);

export default Success;
